<template>
  <div class="dashboard-count-dialog">
    <custom-dialog width="80%" :title="title" :visible="visible"  v-on="$listeners">
      <div class="dialog-body">
        <!-- 表格 -->
        <div class="product-wrap">
          <div class="table-bd">
            <custom-table
              v-if="tableCode"
              index
              ref="table"
              :data="tableList"
              :loading="isLoading"
              :table-code="tableCode"
              @filter="filterChange"
              @sort="sortChange"
              :slots="['bodyNum', 'action']"
              :filterArr="model.type==='unComplete'?[]:['dayNum']"
              height="680px"
            >
              <template slot="bodyNum" slot-scope="scope">
                <!-- <div class="cell-link" @click="onDeviceDetail(scope.row)" v-if="60401000189,60401000182">{{ scope.row.bodyNum }}</div> -->

                <template v-if="scope.row.bodyNum.includes(',')">
                  <!-- 如果 bodyNum 包含逗号，说明有多个 -->
                  <span v-for="(bodyNum, index) in scope.row.bodyNum.split(',')" :key="index" @click="onDeviceDetail(bodyNum)" class="cell-link">{{ bodyNum }}<span v-if="index < scope.row.bodyNum.split(',').length - 1">,</span></span>
                </template>
                <template v-else>
                  <!-- 如果只有一个 bodyNum -->
                  <div class="cell-link" @click="onDeviceDetail(scope.row.bodyNum)">{{ scope.row.bodyNum }}</div>
                </template>
              </template>
              <template slot="action" slot-scope="scope">
                <!-- unUploadRecord: '未上传清洁记录',暂时缺跳转 -->
                <el-button v-if="model.type !== 'unUploadRecord'" type="text" size="mini" @click="onShowDetail(scope.row)">{{ $t('Common.com_detail') }}</el-button>
              </template>
            </custom-table>
          </div>
          <div class="table-page">
            <div class="table-sum-params" v-if="model.type=== 'unUploadMap' && tableList.length > 0">
              <div class="sum-item ml-10">
                <div class="key">{{ $t('base_dashboard_count_dialog.ji_qi_shu') }}：</div>
                <div class="val selected-num">{{ count }}</div>
              </div>
            </div>
            <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{
         $t('Common.com_close')
        }}</el-button>

      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';


export default {
  mixins: [dialogMixins],
  computed: {
    title() {
      // unUploadUsePic: '未上传运行图', unUploadMap: '未上传地图', unUploadRecord: '未上传清洁记录', unComplete: '未完成清洁', cliffCount: '悬崖触发', bumpCount: '碰撞触发'
      const titles = {
        unUploadUsePic: this.$t('base_dashboard_count_dialog.wscyxt'),
        unUploadMap: this.$t('base_dashboard_count_dialog.wscdt'),
        unUploadRecord: this.$t('base_dashboard_count_dialog.wscqjjl'),
        unComplete: this.$t('base_dashboard_count_dialog.wwcqj'),
        cliffCount: this.$t('base_dashboard_count_dialog.xuan_ya_chu_fa'),
        bumpCount: this.$t('base_dashboard_count_dialog.peng_zhuang_chu_fa')
      };
      return titles[this.model.type];
    },
    requestApi() {
      const api = {
        unUploadUsePic: apis.adminPortalDeviceUnUploadUsePicPage,
        unUploadMap: apis.adminPortalDeviceUnUploadMapPage,
        unUploadRecord: apis.adminPortalDeviceUnUploadCleanRecordPage,
        unComplete: apis.adminPortalDeviceUnCompleteRecordPage,
        cliffCount: apis.adminPortalDeviceCliffCountPage,
        bumpCount: apis.adminPortalDeviceBumpeCountPage
      };
      return api[this.model.type];
    },

  },
  data() {
    return {
      tableCode: '',
      formSearch: {
        pageSize: 30,
        pageNum: 1,
        pastEndTime: '',
        pastStartTime: '',
        productCode: '',
        locationName: '',
        customerName: '',
        afterServiceName: '',
        agentCoName: '',
      },
      tableList: [],
      totalRows: null,
      isLoading: false,
      count: 0,
    };
  },
  mounted() {

    this.tableCode = this.model.tableCode;
    this.initDialog();
    if (this.model.formSearch) {
      this.formSearch = this.model.formSearch;
    } else {
      this.$setFormatData(this.formSearch, this.model.data);
    }
    this.getTableList();
    if (this.model.type === 'unUploadMap') {
      this.getTableCount();
    }
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 获取列表
    getTableList: function () {
      // this.isLoading = true;
      this.$getJSON(this.requestApi, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    getTableCount() {
      this.$getJSON(apis.adminPortalDeviceUnUploadMapCount, this.formSearch).then((res) => {
        this.count = res.data.num;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onDeviceDetail(bodyNum) {
      this.jump('/devicedetail', { bodyNum: bodyNum, parentPath: this.$route.path }, null, true);
      this.$emit('openBack', this.formSearch);
      this.closeDialog();
    },
    getSearchItem(row) {
      // 未上传运行图 传机身号/时间段/路线图
      // 未上传地图 传机身号/时间段/定位码/地图槽
      // 未上传清洁记录 未上传清洁记录 页（需开发，传机身号/时间段）缺
      // 未完成清洁 传机身号/时间段/清洁状态
      // 悬崖触发 传机身号/时间段/悬崖次数>=5
      // 碰撞触发 传机身号/时间段/碰撞次数>=5
      const dateTimes = [this.model.data.pastStartTime, this.model.data.pastEndTime];
      const params = {
        unUploadUsePic: {
          workClass: [4, 5],
          hasAttach: [0],
          formSearch: JSON.stringify({
            ...row,
            search: row.bodyNum,
            dateTimes,
            // startTime: '',
            // endTime: ''
          })
        },
        unUploadMap: {
          formSearch: JSON.stringify({
            ...row,
            search: row.bodyNum,
            dateTimes
            // startTime: '',
            // endTime: ''
          })
        },
        // unUploadRecord: apis.adminPortalDeviceUnUploadCleanRecordPage,
        unComplete: {
          endEventVal: ['0', '14'],
          formSearch: JSON.stringify({
            ...row,
            search: row.bodyNum,
            dateTimes,
            productCode: '',
            locationName: ''
          }),
        },
        cliffCount: {
          formSearch: JSON.stringify({
            ...row,
            search: row.bodyNum,
            dateTimes,
            cliffCount: ['5', ''],
            productCode: '',
            locationName: ''
          })
        },
        bumpCount: {
          formSearch: JSON.stringify({
            ...row,
            search: row.bodyNum,
            dateTimes,
            bumpeCount: ['5', ''],
            productCode: '',
            locationName: ''
          })
        },
      };
      return params[this.model.type];
    },
    onShowDetail(row) {
      // futureEndTime: '',
      // futureStartTime: '',
      // pastEndTime: '',
      // pastStartTime: ''
      const searchItem = this.getSearchItem(row);
      this.jump('/redirect/robotLog', searchItem, null, true);
      this.$emit('openBack', this.formSearch);
      this.closeDialog();
    },
  },
};
</script>

<style lang="scss">
.dashboard-count-dialog {

  .table-sum-params {
    float: left;
    overflow: hidden;

    .selected-num {
      padding: 0 5px;
      color: #0d9ae0;
    }

    .sum,
    .price {
      color: #0d9ae0;
    }

    .ml-10 {
      margin-left: 10px;
    }

    .sum-item {
      float: left;
      line-height: 32px;
      font-size: 12px;
      color: #606266;

      .key,
      .val {
        float: left;
      }
    }
  }
}
</style>
